import { lazy } from 'react';
export const AdScoresPage = lazy(() => import(/* webpackChunkName: "adscores" */ '.'));
export default AdScoresPage;
